import 'css-chunksrc/client/pages/capacityPage/table/row/styles.scss';export default {
  "resourceCell": "_resourceCell_g1qmb_1",
  "clickable": "_clickable_g1qmb_15",
  "avatar": "_avatar_g1qmb_19",
  "identity": "_identity_g1qmb_24",
  "name": "_name_g1qmb_28",
  "profession": "_profession_g1qmb_37"
};